import React from 'react';
import { makeStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import MultiOrgDropDown from '../components/MultiOrg';
import Table from './FeedbackTable';
import {LoadingSkeletonGroupWise, LoadingSkeletonTableWise} from '../components/LoadingSkeleton';
import { useSelector } from "react-redux";
import { selectEmail } from "../reducer/authSlice";

const useStyles = makeStyles(theme => ({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    btnPadding :{
      marginRight: "8px",
      marginBottom: "8px",
      fontSize: "0.8rem",
      fontWeight: 500,
      minHeight: "36px",
      borderRadius: "8px",
      textTransform: "none",
      padding: "6px 16px",
      transition: "all 0.2s ease",
      '&:hover': {
        transform: "translateY(-1px)",
        boxShadow: "0 4px 12px rgba(111, 41, 129, 0.2)",
      },
      '@media (max-width: 600px)': {
        fontSize: "0.75rem",
        minHeight: "32px",
        padding: "5px 12px",
        marginRight: "6px",
        marginBottom: "6px",
      },
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
      '@media (max-width: 600px)': {
        minHeight: '120px',
      },
    },
    content: {
      flexGrow: 80,
      padding: theme.spacing(3),
      width: '100%',
      boxSizing: 'border-box',
      overflow: 'hidden',
      '@media (max-width: 600px)': {
        padding: theme.spacing(2),
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
      },
    },
    buttonContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      gap: '0',
      marginBottom: '16px',
      '@media (max-width: 600px)': {
        gap: '0',
        marginBottom: '12px',
      },
    },
    roleTabContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      gap: '8px',
      marginBottom: '20px',
      paddingBottom: '16px',
      borderBottom: '2px solid #f0f0f0',
      '@media (max-width: 600px)': {
        gap: '6px',
        marginBottom: '16px',
        paddingBottom: '12px',
      },
    },
    roleTab: {
      marginRight: "4px",
      marginBottom: "0",
      fontSize: "0.95rem",
      fontWeight: 600,
      minHeight: "42px",
      borderRadius: "8px 8px 0 0",
      textTransform: "none",
      padding: "10px 24px",
      transition: "all 0.2s ease",
      border: "2px solid transparent",
      borderBottom: "none",
      position: "relative",
      '&:hover': {
        backgroundColor: "rgba(111, 41, 129, 0.05)",
      },
      '@media (max-width: 600px)': {
        fontSize: "0.85rem",
        minHeight: "38px",
        padding: "8px 16px",
      },
    },
    roleTabActive: {
      backgroundColor: "rgba(111, 41, 129, 0.1)",
      color: "#6f2981",
      borderColor: "#6f2981",
      borderBottom: "none",
      '&::after': {
        content: '""',
        position: "absolute",
        bottom: "-2px",
        left: 0,
        right: 0,
        height: "2px",
        backgroundColor: "#6f2981",
      },
    },
  }));

  export default function FeedbackGrid(props) {
    const classes = useStyles();
    const email = useSelector(selectEmail);
    const {buttonArray,setTestData, dispatch,loading, _setLoading, _started, _pending, buttonName, setButtonClicked, typeButton, setSelectedType, selectTypeButton,setExamId, examId, setModal,showModal, handleHome, handleIconCLick, menuTitle, setMenuTitle,selectedTab ,setSelectedTab, setCodeLanguages } = props;

    const [tableData, setTabledata] = React.useState({});
    const [role, setRole] = React.useState([]);
    const [selectedRole, setSelectedRole] = React.useState('');
    const [_selectedButton, setSelectedButton] = React.useState('');
    
    const _handleGroupClick = (item) => {
      setButtonClicked(item);
      
      if (buttonArray[selectTypeButton] !== undefined) {
        const typeData = buttonArray[selectTypeButton];
        const groupObj = typeData ? typeData[item] : undefined;
        const innerKey = groupObj ? Object.keys(groupObj)[0] : undefined;
        const arr = innerKey ? groupObj[innerKey] : undefined;
        setTabledata((arr && arr[0]) ? arr[0] : {});
      }
    }

    const handleRoleClick = (item) => {
        setSelectedRole(item);
        
        if (buttonArray[selectTypeButton] !== undefined) {
          const typeData = buttonArray[selectTypeButton];
          const roleGroups = typeData ? typeData[buttonName] : undefined;
          const rowArr = roleGroups ? roleGroups[item] : undefined;
          setTabledata((rowArr && rowArr[0]) ? rowArr[0] : {});
        }
      }

    React.useEffect(() => {
        let isMounted = true;

        // Compute the correct key based on typeButton
        const computedType = typeButton === 'Tests' ? 'TEST' : (typeButton === 'Practice' ? 'PRACTISE' : (typeButton === 'Survey' ? 'SURVEY' : (typeButton === 'Feedback' ? 'FEEDBACK' : (typeButton === 'Completed' ? 'COMPLETED' : (typeButton === 'Expired' ? 'EXPIRED' : typeButton === 'WorkFlow' ? 'WORKFLOW' : '')))));
        if (isMounted) {
          setSelectedType(computedType);
          setMenuTitle(['Feedback','FeedbackCompleted','FeedbackExpired'])
        }

        // Use computedType directly instead of selectTypeButton to avoid stale state
        const typeData = buttonArray ? buttonArray[computedType] : undefined;
        if (typeData && Object.keys(typeData).length > 0) {
          const keys = Object.keys(typeData);
          const firstKey = keys[0];
          const firstGroup = typeData[firstKey];
          const innerFirstKey = firstGroup ? Object.keys(firstGroup)[0] : undefined;
          const firstArr = innerFirstKey ? firstGroup[innerFirstKey] : undefined;

          if (isMounted) {
            setButtonClicked(firstKey);
            setSelectedButton((firstArr && firstArr[0]) ? firstArr[0] : '');

            const rolesCandidateKey = keys[1];
            const rolesCandidate = rolesCandidateKey ? typeData[rolesCandidateKey] : undefined;
            const rolesArray = Array.isArray(rolesCandidate) ? rolesCandidate : [];
            setRole(rolesArray);
            setSelectedRole(rolesArray.length > 0 ? rolesArray[0] : '');

            setTabledata((firstArr && firstArr[0]) ? firstArr[0] : {});
          }
        } else {
          if (isMounted) {
            setTabledata({})
            setButtonClicked({});
            setSelectedButton('')
            setRole([]);
            setSelectedRole('')
          }
        }

        return () => {
          isMounted = false;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [buttonArray, typeButton])
  
    return (
      <main className={classes.content}>
          <div className={classes.toolbar} />
          <b>Login ID:</b> {email}
          <br></br>
          <br></br>
          <MultiOrgDropDown selectedTab = {selectedTab} setSelectedTab = {setSelectedTab} isFeedback={true} handleHome={handleHome} typeButton={typeButton} handleIconCLick={handleIconCLick} menuTitle={menuTitle} />
            <br></br>
            {loading ? <LoadingSkeletonGroupWise />  :
            <Grid style={{ paddingBottom: "0px" }} item xs={12}>
                <div className={classes.roleTabContainer}>
                {
                    role.length > 0 ? role.map((item,index) => {
                        return (<Button key={`gButton${index}`}
                                className={`${classes.roleTab} ${selectedRole === item ? classes.roleTabActive : ''}`}
                                variant="text"
                                onClick={ ()=> handleRoleClick(item)}
                                >
                                  {item}
                                </Button>)

                  }) : null
                }
                </div>
            </Grid>}
            <Grid item xs={12}>
              {loading ? <LoadingSkeletonTableWise /> :
              <Table showModal={showModal} dispatch={dispatch} tableData={tableData} typeButton={typeButton} status='000' setModal={setModal} setTestData={setTestData} examId = {examId} setExamId={setExamId} buttonName={buttonName} setCodeLanguages={setCodeLanguages} />
              }
            </Grid>
      </main>
    );
  }